import { render, staticRenderFns } from "./configAddGroupRule.vue?vue&type=template&id=1f993977&"
import script from "./configAddGroupRule.vue?vue&type=script&lang=js&"
export * from "./configAddGroupRule.vue?vue&type=script&lang=js&"
import style0 from "./configAddGroupRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports